const routesSchema = {
  core: [
    { path: "/", name: "Home", component: "Home" },
    { path: "/contact", name: "Contact", component: "Contact" },
    { path: "/kundli", name: "Kundli", component: "Kundli" },
    { path: "/thank-you", name: "Thank", component: "Thank" },
  ],
};

export default routesSchema;
